<template>
    <div class="container">
        <div class="m-portlet">
        <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                    <h3 class="m-portlet__head-text">
                        Neue Angebotsvorlage
                    </h3>
                </div>
            </div>
        </div>

        <!--begin::Form-->
            <div class="m-portlet__body">
                <el-form :rules="rules" ref="offerTemplate" :model="offerTemplate" label-width="200px">
                    <el-form-item label="Name" prop="name">
                        <el-input v-model="offerTemplate.name"></el-input>
                    </el-form-item>
                    <el-form-item prop="project_type_id" label="Projekt Kategorie">
                        <el-select  v-model="offerTemplate.project_type_id" placeholder="Bitte wählen">
                            <el-option
                                v-for="(item, key) in projectTypeArr"
                                :key="key"
                                :label="item"
                                :value="key">{{item}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Schwierigkeitsgrad" prop="difficulty">
                        <el-select v-model="offerTemplate.difficulty" placeholder="Bitte wählen">
                            <el-option
                                v-for="(item, key) in projectDifficultyArr"
                                :key="key"
                                :label="item"
                                :value="key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Dienstleister Preis">
                        <el-input-number v-model="offerTemplate.service_price" :min="0"></el-input-number>
                    </el-form-item>
                    <el-form-item label="Bilder pro Stunde">
                        <el-input-number v-model="offerTemplate.image_per_hour" :step="1" :min="1"></el-input-number>
                    </el-form-item>
                    <el-form-item label="Geplante Minuten außerhalb der Fotografie">
                        <el-input-number v-model="offerTemplate.init_time_min" :step="15" :min="15"></el-input-number>
                    </el-form-item>
                    <div class="row">
                        <div class="col-9">
                            <el-form-item label="Texte hinzufügen">
                                <el-select
                                    v-model="currentTemplatePartId"
                                    filterable
                                    remote
                                    reserve-keyword
                                    placeholder="Text hinzufügen">
                                    <el-option
                                        v-for="offerTemplatePart in offerTemplateParts"
                                        :key="offerTemplatePart.id"
                                        :label="offerTemplatePart.name"
                                        :value="offerTemplatePart.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-3">
                            <el-button type="success" @click="addtemplatePart()">Hinzufügen</el-button>
                        </div>
                    </div>

                    <div class="mt-4 mb-4">
                        <div class="card">
                            <div class="offer-pdf-prev__container">
                                <div class="offer-pdf-prev">
                                    <h1 class="offer-pdf-prev__headline">Angebot</h1>
                                    <offer-template-part v-for="(offerTemplatePartIndex, index) in offerTemplate.templateParts" :offer-template-part="offerTemplatePartIndex[0]" :key="'of-tpl-part-' + offerTemplatePartIndex[0].id + '#' + index" @deleteElement="deleteElement"></offer-template-part>
                                </div>
                            </div>
                        </div>
                    </div>
                    <el-button type="success" @click="submitForm('offerTemplate')">Speichern</el-button>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import OfferTemplateAPI from "~/api/offerTemplate";

import OfferTemplatePart from "./offer-template/OfferTemplatePart";

    export default{
        components: {
            OfferTemplatePart,
        },
        props: {
            offerTemplateParts: Array,
            projectTypeArr: Object,
            projectDifficultyArr: Object,
            offerTemplateObject: Object
        },
        data() {
            return {
                offerTemplate:{
                    name: null,
                    difficulty: null,
                    service_price: 0.5,
                    image_per_hour: 5,
                    init_time_min: 60,
                    project_type_id: null,
                    templateParts: []
                },
                rules: {
                    name: [
                        { required: true, message: 'Bitte Namen ein geben', trigger: 'blur' },
                    ],
                    template: [
                        { required: true, message: 'Bitte Beschreibungstext eingeben', trigger: 'blur' },
                    ],
                    difficulty: [
                        { required: true, message: 'Bitte Schwierigkeitsgrad eingeben', trigger: 'blur' },
                    ],
                    project_type_id: [
                        { required: true, message: 'Bitte Projekttyp wählen', trigger: 'change' }
                    ],
                },
                currentTemplatePartId: null
            }
        },
        created() {
            this.offerTemplate = this.offerTemplateObject;
        },
        methods:{
            addtemplatePart(){
                let them = this;
                let tmp = this.offerTemplateParts.filter(function(el) {
                    if (el.id === them.currentTemplatePartId){
                        return el;
                    }
                });
                them.offerTemplate.templateParts.push(tmp);
            },
            deleteElement(variable) {
                let them = this;
                let tmpArr = [];
                this.offerTemplate.templateParts.filter(function(el) {
                    console.log(el[0].id);
                    if (el[0].id !== variable){
                        tmpArr.push(el);
                    }
                });
                them.offerTemplate.templateParts = tmpArr;
            },
            submitForm(formName) {
                let that = this;

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        OfferTemplateAPI.postUpdateOfferTemplate({
                            offerTemplate: that.offerTemplate,
                        }).then(function (response) {
                            window.location.href = "/angebots-vorlagen/" + response.data;
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }
</script>
